export default __webpack_public_path__ + "media/background-intl.0faeb2ee270b877644931aab53b05fc5.webp";